"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var IconIconRemoveCircle = (0, _createIconComponent["default"])({
  fillContent: /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM6 11a1 1 0 100 2h12a1 1 0 100-2H6z",
    clipRule: "evenodd"
  })),
  lightContent: /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6 12a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11A.5.5 0 016 12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11zm0 1c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    clipRule: "evenodd"
  })),
  regularContent: /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6 11.25a.75.75 0 000 1.5h12a.75.75 0 000-1.5H6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M0 12c0 6.617 5.383 12 12 12s12-5.383 12-12S18.617 0 12 0 0 5.383 0 12zm1.5 0C1.5 6.21 6.21 1.5 12 1.5S22.5 6.21 22.5 12 17.79 22.5 12 22.5 1.5 17.79 1.5 12z",
    clipRule: "evenodd"
  })),
  height: undefined,
  width: undefined,
  viewBox: "0 0 24 24"
});
IconIconRemoveCircle.displayName = 'IconIconRemoveCircle';
var _default = exports["default"] = IconIconRemoveCircle;